<template>
  <v-card class="mb-4 rounded-lg elevation-1 border-sm" color="surface">
    <!-- Header / Title Bar -->
    <div
      class="d-flex flex-wrap align-center justify-space-between py-3 px-4 bg-grey-lighten-4 border-b"
    >
      <div class="d-flex flex-column mb-1 mb-sm-0">
        <!-- Client Name or Default Title -->
        <h2 class="text-h6 font-weight-bold text-primary mb-0">
          <template v-if="hasActiveData">
            {{ activeClientName }}
          </template>
          <template v-else>
            Invoices, Payments Receipts &
            <span class="primary--text font-italic">SARS</span> Prep Tool
          </template>
        </h2>

        <!-- Reference Subtitle -->
        <div
          v-if="hasActiveData"
          class="text-caption text-medium-emphasis font-weight-medium"
        >
          <v-row>
            <v-col :cols="6"
              >Ref:
              <span class="text-high-emphasis">{{ activeRefNumber }}</span>
            </v-col>
            <v-col :cols="6"
              ><v-btn
                color="success"
                outlined
                dark
                small
                v-if="
                  getAppMode !== 'legal' &&
                  selectedInvoice &&
                  selectedInvoice.quote_number
                "
                @click="convertSelectedQuoteToInvoice"
                ><v-icon>mdi-cash</v-icon>Convert to Invoice</v-btn
              ></v-col
            >
          </v-row>
        </div>
      </div>

      <!-- Print Invoice Button -->
      <div
        class="d-flex align-center flex-wrap gap-2 mt-2 mt-sm-0"
        v-if="selectedInvoice"
      >
        <v-chip
          color="primary"
          variant="tonal"
          size="small"
          class="font-weight-medium"
          prepend-icon="mdi-text-short"
        >
          <span class="text-truncate" style="max-width: 300px">
            <ProFormaGenerator
              :invoice="selectedInvoice"
              :title="selectedInvoice.invoice_number ? 'Invoice' : 'Quotation'"
              :buttunWithText="true"
            ></ProFormaGenerator>
          </span>
        </v-chip>
      </div>
    </div>

    <!-- Details Grid -->
    <v-card-text v-if="hasActiveData" class="py-4 px-4">
      <v-row dense class="ga-y-2">
        <v-col cols="12" sm="6" md="4">
          <div class="d-flex align-center">
            <v-avatar color="grey-lighten-3" size="32" class="mr-3">
              <v-icon size="18" color="grey-darken-2">mdi-domain</v-icon>
            </v-avatar>
            <div class="text-truncate">
              <div class="text-caption text-medium-emphasis">Institution</div>
              <div class="text-body-2 font-weight-semibold text-truncate">
                {{ activeClient?.institution || "N/A" }}
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <div class="d-flex align-center">
            <v-avatar color="grey-lighten-3" size="32" class="mr-3">
              <v-icon size="18" color="grey-darken-2">mdi-phone-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-caption text-medium-emphasis">Phone</div>
              <div class="text-body-2 font-weight-semibold">
                {{ activeClient?.phone || "N/A" }}
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <div class="d-flex align-center">
            <v-avatar color="grey-lighten-3" size="32" class="mr-3">
              <v-icon size="18" color="grey-darken-2">mdi-email-outline</v-icon>
            </v-avatar>
            <div class="text-truncate">
              <div class="text-caption text-medium-emphasis">Email</div>
              <div class="text-body-2 font-weight-semibold text-truncate">
                <a
                  v-if="activeClient?.email"
                  :href="`mailto:${activeClient.email}`"
                  class="text-decoration-none text-primary"
                >
                  {{ activeClient.email }}
                </a>
                <span v-else class="text-low-emphasis">N/A</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import invoicesAndQuotesJs from "@/plugins/invoicesAndQuotes";
import ProFormaGenerator from "@/modules/CaseManager/ProFormaGenerator.vue";
export default {
  name: "InvoiceHeader",
  props: {
    selectedInvoice: {
      type: Object,
      default: null,
    },
  },
  components: { ProFormaGenerator },
  computed: {
    getAppMode() {
      return this.$store.getters.getAppMode;
    },
    hasActiveData() {
      return Boolean(this.selectedInvoice);
    },
    activeSource() {
      return this.selectedInvoice || {};
    },
    activeClient() {
      return this.activeSource.client || null;
    },
    activeClientName() {
      if (!this.hasActiveData) return "Client";
      return (
        this.selectedInvoice?.applicant ||
        this.selectedInvoice?.client?.name ||
        "Client"
      );
    },
    activeRefNumber() {
      return (
        this.selectedInvoice?.invoice_number ||
        this.selectedInvoice?.quote_number ||
        "N/A"
      );
    },
    activeDescription() {
      return this.selectedInvoice?.description || "";
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  methods: {
    async convertSelectedQuoteToInvoice() {
      const selectedQuotations = [this.selectedInvoice];
      if (!this.selectedInvoice || selectedQuotations.length < 1) return;

      this.$store.commit("setLoader", true);
      const res = await invoicesAndQuotesJs.convertSelectedQuotesToInvoices(
        selectedQuotations
      );
      this.$store.commit("setLoader", false);

      const text = selectedQuotations.length > 1 ? "Quotations" : "Quotation";

      if (res && res.status === "success") {
        this.$toast.success(text + " converted successfully!", {
          duration: 1000,
        });
        window.location.reload();
        //this.$emit("converted-to-invoice", res.invoices[0]);
      } else {
        this.$toast.error("Oops, Failed to convert", {
          duration: 1000,
        });
      }
    },
  },
};
</script>
